export default () => ({
	list: {
		totalCount: 0,
		products: [],
		page: 1,
		itemsPerPage: 10,
		searchTerm: null
	},

	detail: {
		locale: null,
		product: null
	},

	benefitGraph: [],

	errors: {},
	events: []
})
